import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=5529c131&scoped=true&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"
import style1 from "./opinion.vue?vue&type=style&index=1&id=5529c131&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529c131",
  null
  
)

export default component.exports